// OTOMATIK URETILIR (scripts/fetch-businesses.mjs) — elle duzenleme; git'e girmez.
import type { EsnafItem } from '../pages/esnaf/esnafData';

export const BUILD_ESNAF: EsnafItem[] = [
  {
    "name": "Cleanmax Arnavutkoy",
    "slug": "cleanmax-arnavutkoy",
    "logo": "/img/business-images/f0afb485-3c82-4c63-b272-435911a72ec6/logo.jpg",
    "mahalle": "Anadolu",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Desmoda",
    "slug": "desmoda",
    "logo": "/img/business-images/ccea246a-ea36-4e0c-bc5d-6db9785d904a/logo.jpg",
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "YES İNVEST GAYRİMENKUL",
    "slug": "ates-ucuzluk-pazari",
    "logo": "/img/business-images/308a7953-7628-4c19-930d-57435da3258b/logo.jpg",
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Fzmsuaritmasistemleri",
    "slug": "fzmsuaritmasistemleri",
    "logo": "/img/business-images/c705abb3-a571-444f-902b-4589f05e468f/logo.jpg",
    "mahalle": "Anadolu",
    "ilce": "Arnavutköy"
  },
  {
    "name": "His Duşakabin",
    "slug": "his-dusakabin",
    "logo": "/img/business-images/21cd6999-a874-401e-a1cb-72e1c55a1687/logo.jpg",
    "mahalle": "Anadolu",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Modern Mekanik Tesisat",
    "slug": "modern-mekanik-tesisat",
    "logo": "/img/business-images/2b00a241-4894-4630-a60f-00bc9cd20bb8/logo_1786372500641.jpg",
    "mahalle": "Anadolu",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Kübra Özgündüz Estetik ve Güzellik Merkezi",
    "slug": "kubra-ozgunduz-estetik-ve-guzellik-merkezi",
    "logo": "/img/business-images/7adbe0b4-a6d7-4a6b-85bf-46058c038695/logo_1787100414838.jpg",
    "mahalle": "Bolluca",
    "ilce": "Arnavutköy"
  },
  {
    "name": "TUYA metal",
    "slug": "tuya-metal",
    "logo": "/img/business-images/e2a41f55-806a-418c-8986-16ccda6ba304/logo_1787483273872.jpg",
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "TEKNİK ELEKTRİK",
    "slug": "teknik-elektrik",
    "logo": "/img/business-images/058447c1-f392-408c-a54e-59fd8dfa0a45/logo_1787640481658.jpg",
    "mahalle": "Arnavutköy Merkez",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Kısmet pide",
    "slug": "kismet-pide",
    "logo": "/img/business-images/f5bc6060-e3fc-4b35-8fb0-f7abb568b16e/logo_1788170438367.jpg",
    "mahalle": "Cebeci",
    "ilce": "Sultangazi"
  },
  {
    "name": "MF REKLAM",
    "slug": "mf-reklam",
    "logo": "/img/business-images/50da0f11-f0a9-443b-962c-b328cc702a9e/logo_1788722599518.jpg",
    "mahalle": "Haraççı",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Sütçü abla 2",
    "slug": "sutcu-abla-2",
    "logo": "/img/business-images/d17bf9ad-3ea7-4b8d-a2ee-eac8129f4e67/logo_1789590003099.jpg",
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Şensoy Yapı Dekorasyon",
    "slug": "sensoy-yapi-dekorasyon",
    "logo": "/img/business-images/6bb30298-5ad7-4c27-a67d-241b6a275e00/logo_1790474447234.jpg",
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Atmaca Sigorta Aracılık Hizmetleri",
    "slug": "atmaca-sigorta-aracilik-hizmetleri",
    "logo": "/img/business-images/b80aea77-1e32-4f28-a478-46983eecccd0/logo_1790943985182.jpg",
    "mahalle": "Taşoluk",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Mavi patiseria",
    "slug": "mavi-patiseria",
    "logo": null,
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Ateş iletişim",
    "slug": "ates-iletisim",
    "logo": null,
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "El emeği",
    "slug": "el-emegi",
    "logo": null,
    "mahalle": "Mavigöl",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Oto Kuaför",
    "slug": "oto-kuafor",
    "logo": null,
    "mahalle": "Arnavutköy Merkez",
    "ilce": "Arnavutköy"
  },
  {
    "name": "İstanbul bilgisayar & elektronik ve güvenlik sistemleri",
    "slug": "istanbul-bilgisayar-elektronik-ve-guvenlik-sistemleri",
    "logo": null,
    "mahalle": "Bolluca",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Genç Av Bayii",
    "slug": "genc-av-bayii",
    "logo": null,
    "mahalle": "Arnavutköy Merkez",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Kozan Teknik",
    "slug": "kozan-teknik",
    "logo": null,
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Karakaya Cam ve Pimapen Sistemleri",
    "slug": "karakaya-cam-ve-pimapen-sistemleri",
    "logo": null,
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Piri Cilingir",
    "slug": "piri-cilingir",
    "logo": null,
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Altın Oto Lastik",
    "slug": "altin-oto-lastik",
    "logo": null,
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Ünal Teknik",
    "slug": "unal-teknik",
    "logo": null,
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Has Çiğköfte",
    "slug": "has-cigkofte",
    "logo": null,
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "ZIRVE ELEKTRONIK",
    "slug": "zirve-elektronik",
    "logo": null,
    "mahalle": "Arnavutköy Merkez",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Karakaş mobilya",
    "slug": "karakas-mobilya",
    "logo": null,
    "mahalle": "Anadolu",
    "ilce": "Arnavutköy"
  },
  {
    "name": "dkdkmd",
    "slug": "dkdkmd",
    "logo": null,
    "mahalle": "Topraklık",
    "ilce": "Çankaya"
  },
  {
    "name": "Zurna Dürüm Karlıbayır",
    "slug": "zurna-durum-karlibayir",
    "logo": null,
    "mahalle": null,
    "ilce": null
  },
  {
    "name": "ATES ALISVERIS MERKEZI",
    "slug": "ates-alisveris-merkezi",
    "logo": null,
    "mahalle": "Karlıbayır",
    "ilce": "Arnavutköy"
  },
  {
    "name": "Eve ofis temizliği",
    "slug": "eve-ofis-temizligi",
    "logo": null,
    "mahalle": "Taşoluk",
    "ilce": "Arnavutköy"
  }
];
